import React from 'react'
import FetchData from '../../shared/fetchData'
import ContentForm from '../../components/UI/ContentForm/ContentForm'
import Button from '../../components/UI/Button/Button'
import Profile from '../../components/Profile/Profile'
import './MyProfile.css'
import Fade from 'react-reveal/Fade'

        const MyProfile = (props) => {

    const [profileInfo, setProfileInfo] = React.useState('')
    const [edit, setEdit] = React.useState(false)
    const [unit, setUnit] = React.useState('')

    React.useEffect(() => {
        var info = {
            "version": "mtpx001"
        }
        var raw = JSON.stringify(info)
        var url = 'management/api/v1/users/getMyInfo'
        FetchData(raw, url).then(response => response.json())
                .then(result => {
                    setProfileInfo(result.user)
                    var info = {
                        "version": "mtpx001"
                    }
                    var raw = JSON.stringify(info)
                    var url = 'management/api/v1/units/getMyUnitInfo'
                    FetchData(raw, url).then(response => response.json())
                            .then(result => {
                                setUnit(result.unit)
                            })
                            .catch(error => console.log(error))
                })
                .catch(error => console.log(error))
    }, [])

    const editProfile = (event) => {
        setEdit(true)
    }
    const back = (event) => {
        setEdit(false)
    }
    const refreshInfo = (event) => {
        setEdit(false)
        var info = {
            "version": "mtpx001"
        }
        var raw = JSON.stringify(info)
        var url = 'management/api/v1/users/getMyInfo'
        FetchData(raw, url).then(response => response.json())
                .then(result => {
                    setProfileInfo(result.user)
                })
                .catch(error => console.log(error))
    }

    return (
            <Fade duration={200} left cascade>
                <div>
                    {!edit ?
                            <div className='row justify-content-center'>
                                <div className='my-pro-cntnr'>
                                    <ContentForm headetText='اطلاعات من'>
                                        <div className="col-12">
                                            <div className="row pl-4" dir="ltr">
                                                <Button btnType="Edit" clicked={editProfile} >ویرایش</Button>
                                            </div>
                                        </div>
                                        <div className='my-pro-frm'>
                                            <div className="col-6 mt-4 hulf-small">
                                                نام کاربری: {profileInfo.username}
                                            </div>
                                            <div className="col-6 mt-4 hulf-small">
                                                شماره همراه: {profileInfo.cellNumber}
                                            </div>
                                            <div className="col-6 mt-4 hulf-small">
                                                نام: {profileInfo.name}
                                            </div>
                                            <div className="col-6 mt-4 hulf-small">
                                                نام خانوادگی: {profileInfo.lastname}
                                            </div>
                                        </div>
                                        <div className='my-pro-frm'>
                                            <div className="col-6 mt-4 hulf-small">
                                                نام واحد: {unit.unitName}
                                            </div>
                                            <div className="col-6 mt-4 hulf-small">
                                                لینک پرداخت: {unit.retrievePaymentLinkApi}
                                            </div>
                                            <div className="col-6 mt-4 hulf-small">
                                                api پرداخت: {unit.inquiryPaymentApi}
                                            </div>
                                            <div className="col-6 mt-4 hulf-small">
                                                موجودی: {unit.balance}
                                            </div>
                                        </div>
                                    </ContentForm>
                                </div>
                            </div>
                                :
                            <Profile refreshInfo={refreshInfo} back={back} profile={profileInfo} />
                    }
                </div>
            </Fade>
            )
}

export default MyProfile